import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=051c88f0&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=051c88f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c88f0",
  null
  
)

export default component.exports